import { HtmlViewerModule } from '../../components/html-viewer/html-viewer.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LiveUpdatePage } from './live-update.page';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, TranslateModule, HtmlViewerModule],
  declarations: [LiveUpdatePage],
})
export class LiveUpdateModule {}
